// @flow
function getLabelGA(facetId) {
  switch (facetId) {
    case '':
      return null;
    case 'activities':
      return 'whichActivities';
    case 'destinations':
      return 'whichDestinations';
    default:
      // 'when', 'who', 'where'
      return facetId;
  }
}

export const getActiveFacetTabTrackingData = ({ facetId }: { facetId: ?string }) => ({
  actionGA: 'smartCriterias',
  labelGA: getLabelGA(facetId),
});
